// extracted by mini-css-extract-plugin
export var layoutContainer = "_4t-0";
export var layoutContainerNoRounding = "_4t-6";
export var layoutContainerOpen = "_4t-5";
export var layoutContainerResizing = "_4t-1";
export var mainContent = "_4t-2";
export var resizeDivider = "_4t-3";
export var slidePanel = "_4t-4";